import MineLottery from "./mine-lottery/index";

export default MineLottery;
